<template>
  <div>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Bootstrap Popovers</strong>
        <div class="card-header-actions">
          <a
            href="https://coreui.io/vue/docs/directives/popover"
            class="card-header-action"
            rel="noreferrer noopener"
            target="_blank"
          >
            <small class="text-muted">docs</small>
          </a>
        </div>
      </c-card-header>
      <c-card-body>
        <c-row>
          <c-col col="6">
            <div class="my-3 text-center">
              <c-button
                v-c-popover="{
                  header: 'Popover header',
                  content: 'I am popover content!',
                }"
                color="primary"
              >
                Click Me
              </c-button>
            </div>
          </c-col>
          <c-col col="6">
            <div class="my-3 text-center">
              <c-button
                v-c-popover="{
                  header: 'Popover!',
                  content: 'I start <strong>open</strong>',
                  active: true,
                }"
                color="primary"
              >
                Click me
              </c-button>
            </div>
          </c-col>
        </c-row>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Popovers</strong>
        <small>placement</small>
      </c-card-header>
      <c-card-body class="my-3">
        <c-row>
          <c-col v-for="placement in placements" :key="placement" md="4" class="py-4 text-center">
            <c-button
              v-c-popover="{
                header: 'Popover!',
                content: `Placement ${placement}`,
                placement,
              }"
              color="primary"
            >
              {{ placement }}
            </c-button>
          </c-col>
        </c-row>
      </c-card-body>
    </c-card>
  </div>
</template>

<script>
export default {
  name: 'Popovers',
  data() {
    return {
      placements: [
        'top-start',
        'top',
        'top-end',
        'bottom-start',
        'bottom',
        'bottom-end',
        'right-start',
        'right',
        'right-end',
        'left-start',
        'left',
        'left-end',
      ],
    };
  },
};
</script>
